import { createGlobalStyle } from 'styled-components';

export const IcebergMUIStyles = createGlobalStyle`
    /*****
    ANM form styles
    *****/

    /* FormLabel */
    .MuiFormLabel-root.anmForm {
        /*
            we can't use flex 'align-items: center' to center the label text with the input b/c when
            the input has an error message, the label gets centered relative to that too, so this is
            the compromise: just push it down a bit.
        */
        margin-top: 5px;
        width: auto; /* label should have a wrapping div with width: 40%; */
        color: ${(props) => props.theme.palette.icebergForm.formLabelColor};
    }
    .MuiFormLabel-root.anmForm .MuiFormLabel-asterisk {
        color: ${(props) =>
            props.theme.palette.icebergForm.formLabelColorError};
    }

    /*
        TextInput
        this is just for the input element itself, which is wrapped by MuiOutlinedInput-notchedOutline below.
        MuiOutlinedInput-notchedOutline handles the border.
    */
    .MuiTextField-root.anmForm input.MuiInputBase-input.MuiOutlinedInput-input {
        box-sizing: border-box;
        height: 32px;
        padding: 4px 16px;
        border-radius: 4px;
        font-size: 13px;
        color: ${(props) =>
            props.theme.palette.icebergForm.textFieldInputColor};
        background-color: ${(props) =>
            props.theme.palette.icebergForm.textFieldInputBackgroundColor};
    }
    .MuiTextField-root.anmForm
        input.MuiInputBase-input.MuiOutlinedInput-input:read-only {
        background-color: ${(props) =>
            props.theme.palette.icebergForm
                .textFieldInputBackgroundColorReadOnly};
        color: ${(props) =>
            props.theme.palette.icebergForm.textFieldInputColorReadOnly};
    }

    // Overwrite MUI
    .anmForm .MuiInputBase-root.MuiOutlinedInput-root,
    .anmForm.MuiInputBase-root.MuiOutlinedInput-root {
        border: none !important;
    }


    /*
        TextInput
        MuiOutlinedInput-notchedOutline handles the border.
    */
    .MuiTextField-root.anmForm .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) =>
            props.theme.palette.icebergForm.textFieldOutline};
    }
    .MuiTextField-root.anmForm .Mui-error .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) =>
            props.theme.palette.icebergForm.textFieldOutlineError};
    }
    /*
        TextInput
        This next chunk handles the various hover and focus states of the border.
    */
    /* error state (class: .Mui-error) - error + focused, error + focused w/ hover, error + not focused w/ hover */
    .MuiTextField-root.anmForm
        .Mui-error.Mui-focused
        .MuiOutlinedInput-notchedOutline,
    .MuiTextField-root.anmForm
        .Mui-error.Mui-focused
        input.MuiInputBase-input.MuiOutlinedInput-input:hover
        + .MuiOutlinedInput-notchedOutline,
    .MuiTextField-root.anmForm
        .Mui-error
        input.MuiInputBase-input.MuiOutlinedInput-input:hover
        + .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) =>
            props.theme.palette.icebergForm.textFieldOutlineFocused};
        border-width: 1px;
    }
    /* focused state (class: .Mui-focused) - focused, focused w/ hover */
    .MuiTextField-root.anmForm .Mui-focused .MuiOutlinedInput-notchedOutline,
    .MuiTextField-root.anmForm
        .Mui-focused
        input.MuiInputBase-input.MuiOutlinedInput-input:hover
        + .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) =>
            props.theme.palette.icebergForm.textFieldOutlineFocused};
        border-width: 1px;
    }
    /* readonly state (input:read-only) - non-focused, focused w/ hover */
    .MuiTextField-root.anmForm
        input.MuiInputBase-input.MuiOutlinedInput-input:read-only
        + .MuiOutlinedInput-notchedOutline,
    .MuiTextField-root.anmForm
        .Mui-focused
        input.MuiInputBase-input.MuiOutlinedInput-input:read-only:hover
        + .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) =>
            props.theme.palette.icebergForm.textFieldOutline};
        border-width: 1px;
    }
    /* non-focused, non-error hover state */
    .MuiTextField-root.anmForm
        input.MuiInputBase-input.MuiOutlinedInput-input:hover
        + .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) =>
            props.theme.palette.icebergForm.textFieldOutline};
    }

    /*
        <Select />
    */
    .anmForm.MuiOutlinedInput-root .MuiSelect-select.MuiSelect-outlined {
        box-sizing: border-box;
        height: 32px;
        line-height: 24px;
        padding-top: 4px;
        padding-bottom: 4px;
        padding-left: 16px;
        background-color: ${(props) =>
            props.theme.palette.icebergForm.selectBackgroundColor};
    }

    /*
        Select
        Hover states for the notchedOutline
    */
    .anmForm.MuiOutlinedInput-root:hover fieldset.MuiOutlinedInput-notchedOutline {
        border-color: ${(props) =>
            props.theme.palette.icebergForm.selectOutline};
    }
    .anmForm.MuiOutlinedInput-root.Mui-focused:hover
        fieldset.MuiOutlinedInput-notchedOutline,
    .anmForm.MuiOutlinedInput-root.Mui-focused
        fieldset.MuiOutlinedInput-notchedOutline {
        border-color: ${(props) =>
            props.theme.palette.icebergForm.selectOutline};
        border-width: 1px;
    }

    /*
        Select
        .MuiSelect-icon handles the arrow icon
    */
    .anmForm.MuiOutlinedInput-root svg.MuiSelect-icon {
        border-left: 1px solid;
        border-left-color: ${(props) =>
            props.theme.palette.icebergForm.chevronIcon};
        height: 22px;
        padding-left: 6px;
        right: 8px;
        top: 6px;
        width: 28px;
    }
    .anmForm.MuiOutlinedInput-root svg.MuiSelect-icon.MuiSelect-iconOpen {
        border: none;
        border-right: 1px solid; /* blueGray500 */
        border-right-color: ${(props) =>
            props.theme.palette.icebergForm.chevronIcon};
        padding-left: 0;
        padding-right: 8px;
        right: 8px;
    }
`;
